<template>
  <div>
    <van-cell class="ry-form__rtf" v-if="true">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead"
          class="ry-form__rtf-read ql-container ql-snow ">

          <template v-if="current.value && current.value.length">

            <froalaView v-if="$store.getters.newRtf" v-model="current.value"></froalaView>

            <div
              v-else
              class="ql-editor"
              v-html="current.value">
            </div>
          </template>

          <div v-else>
            暂无内容
          </div>
        </div>
        <ry-quill-editor
          v-if="!isRead"
          @change="controlChange"
          :disabled="isReadOnly"
          placeholder="请输入内容"
          :content.sync="current.value"
          :showQuickBtn="false"
          :heightMin="80"
          :heightMax="120">
        </ry-quill-editor>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__rtf-compact">

      <van-field
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div class="ry-form__rtf-read ql-container ql-snow ">

            <template v-if="current.value && current.value.length">

              <froalaView v-if="$store.getters.newRtf" v-model="current.value"></froalaView>

              <div
                v-else
                class="ql-editor"
                v-html="current.value">
              </div>
            </template>

            <div v-else class="field-empty-tips">
              暂无内容
            </div>
          </div>
        </template>
      </van-field>

    </div>
  </div>

</template>

<script>
  import { current } from './mixin'
  export default {
    mixins: [current]
  }
</script>

<style lang="less">

  .ry-form__rtf {

    .van-cell__title {
      width: 100%;

      .van-cell__label {
        width: 100%;
      }
    }
  }
</style>